import { Table, Tooltip, Space } from 'antd';
import dayjs from 'dayjs';
import { DatePopupconfirm } from '../../../components/datePopupConfirm';

export default function SubscriptionItemsTable({ items, customerId, markInactive}) {
  // Sub-table columns (Subscription Items)
  const subscriptionColumns = [
    {
      title: 'Product Name',
      dataIndex: ['product', 'name'],
      key: 'product_name',
    },
    {
      title: 'SKU',
      dataIndex: ['product', 'sku'],
      key: 'sku',
    },
    {
      title: 'Bundle',
      dataIndex: ['product', 'is_bundled'],
      key: 'is_bundled',
      render: (value) => value ? 'Yes' : 'No'
    },
    {
      title: 'Start Date',
      dataIndex: ['start_date'],
      key: 'start_date',
      render: (value) => dayjs(value).format('MM/DD/YYYY')
    },
    {
      title: 'End Date',
      dataIndex: ['end_date'],
      key: 'end_date',
      render: (value) => dayjs(value).format('MM/DD/YYYY')
    },
    {
      title: 'Terms',
      dataIndex: ['term'],
      key: 'term',
    },
    {
      title: 'Invoice Due Days',
      dataIndex: ['invoice_due_days'],
      key: 'invoice_due_days',
    },
    {
      title: 'Unit Price',
      dataIndex: 'unit_price',
      key: 'unit_price',
      render: (value) => (typeof value === 'number' ? value.toFixed(2): value),
    },
    {
      title: 'Discount (%)',
      dataIndex: 'discount_percentage',
      key: 'discount_percentage',
      render: (value) => (typeof value === 'number' ? value.toFixed(2): value),
    },
    {
      title: 'Discount Amount',
      dataIndex: 'discount_amount',
      key: 'discount_amount',
      render: (value) => (typeof value === 'number' ? value.toFixed(2): value),
    },
    {
      title: 'Final Amount',
      dataIndex: 'amount',
      key: 'amount',
      render: (value) => (typeof value === 'number' ? value.toFixed(2): value),
    },
    // {
    //   title: 'Status',
    //   dataIndex: 'is_active',
    //   key: 'is_active',
    //   render: (value) => (value ? 'Active' : 'Inactive'),
    // },
    {
      title: 'Actions', key: 'actions',
      render: (_, record) => {
        return <Space gap="small" wrap>
          <Tooltip placement='left' title={ !record.is_active ? `Deactivation Effective Date: ${dayjs(record.last_deactivation_date).format('MM/DD/YYYY')}` : '' }>
            <span>
              <DatePopupconfirm
                onConfirm={markInactive}
                customerId={customerId}
                record_id={record.id}
                is_active={record.is_active}
              />
            </span>
          </Tooltip>
        </Space>
      }
    }
  ];
  return <Table rowKey="id" columns={subscriptionColumns} dataSource={items} pagination={false} size="small"/>
}